
import { WorldCity } from '../types';

// Expansión de Polonia - 90 ciudades adicionales
export const polandAdditionalCities: WorldCity[] = [
  { name: 'Krakow', slug: 'krakow', population: 779115 },
  { name: 'Lodz', slug: 'lodz', population: 679941 },
  { name: 'Wroclaw', slug: 'wroclaw', population: 643782 },
  { name: 'Poznan', slug: 'poznan', population: 538633 },
  { name: 'Gdansk', slug: 'gdansk', population: 470907 },
  { name: 'Szczecin', slug: 'szczecin', population: 401907 },
  { name: 'Bydgoszcz', slug: 'bydgoszcz', population: 350178 },
  { name: 'Lublin', slug: 'lublin', population: 339784 },
  { name: 'Katowice', slug: 'katowice', population: 292774 },
  { name: 'Bialystok', slug: 'bialystok', population: 297554 },
  { name: 'Gdynia', slug: 'gdynia', population: 246309 },
  { name: 'Czestochowa', slug: 'czestochowa', population: 220635 },
  { name: 'Radom', slug: 'radom', population: 214566 },
  { name: 'Sosnowiec', slug: 'sosnowiec', population: 202036 },
  { name: 'Torun', slug: 'torun', population: 202562 },
  { name: 'Kielce', slug: 'kielce', population: 196335 },
  { name: 'Gliwice', slug: 'gliwice', population: 179806 },
  { name: 'Zabrze', slug: 'zabrze', population: 173374 },
  { name: 'Bytom', slug: 'bytom', population: 166795 },
  { name: 'Olsztyn', slug: 'olsztyn', population: 171249 },
  { name: 'Bielsko-Biala', slug: 'bielsko-biala', population: 171505 },
  { name: 'Rzeszow', slug: 'rzeszow', population: 196821 },
  { name: 'Ruda Slaska', slug: 'ruda-slaska', population: 138000 },
  { name: 'Rybnik', slug: 'rybnik', population: 138696 },
  { name: 'Tychy', slug: 'tychy', population: 127831 },
  { name: 'Dabrowa Gornicza', slug: 'dabrowa-gornicza', population: 120339 },
  { name: 'Plock', slug: 'plock', population: 119425 },
  { name: 'Elblag', slug: 'elblag', population: 119317 },
  { name: 'Walbrzych', slug: 'walbrzych', population: 110844 },
  { name: 'Wloclawek', slug: 'wloclawek', population: 109980 },
  { name: 'Tarnow', slug: 'tarnow', population: 108470 },
  { name: 'Chorzow', slug: 'chorzow', population: 107807 },
  { name: 'Koszalin', slug: 'koszalin', population: 107387 },
  { name: 'Kalisz', slug: 'kalisz', population: 99106 },
  { name: 'Legnica', slug: 'legnica', population: 99350 },
  { name: 'Grudziadz', slug: 'grudziadz', population: 95789 },
  { name: 'Slupsk', slug: 'slupsk', population: 91307 },
  { name: 'Jaworzno', slug: 'jaworzno', population: 91235 },
  { name: 'Jastrzebie-Zdroj', slug: 'jastrzebie-zdroj', population: 89206 },
  { name: 'Nowy Sacz', slug: 'nowy-sacz', population: 83116 },
  { name: 'Jelenia Gora', slug: 'jelenia-gora', population: 78335 },
  { name: 'Siedlce', slug: 'siedlce', population: 77872 },
  { name: 'Myszkow', slug: 'myszkow', population: 72124 },
  { name: 'Piekary Slaskie', slug: 'piekary-slaskie', population: 56394 },
  { name: 'Ostrowiec Swietokrzyski', slug: 'ostrowiec-swietokrzyski', population: 69078 },
  { name: 'Gniezno', slug: 'gniezno', population: 67982 },
  { name: 'Stalowa Wola', slug: 'stalowa-wola', population: 60179 },
  { name: 'Zakopane', slug: 'zakopane', population: 27266 },
  { name: 'Oswiecim', slug: 'oswiecim', population: 38052 },
  { name: 'Stargard', slug: 'stargard', population: 67293 },
  { name: 'Pabianice', slug: 'pabianice', population: 65283 },
  { name: 'Belchatow', slug: 'belchatow', population: 56913 },
  { name: 'Lomza', slug: 'lomza', population: 62802 },
  { name: 'Inowroclaw', slug: 'inowroclaw', population: 73048 },
  { name: 'Dzierzoniow', slug: 'dzierzoniow', population: 33388 },
  { name: 'Lubin', slug: 'lubin', population: 71734 },
  { name: 'Chelmno', slug: 'chelmno', population: 18915 },
  { name: 'Sanok', slug: 'sanok', population: 38397 },
  { name: 'Biala Podlaska', slug: 'biala-podlaska', population: 57541 },
  { name: 'Przemysl', slug: 'przemysl', population: 60442 },
  { name: 'Suwalki', slug: 'suwalki', population: 69317 },
  { name: 'Pila', slug: 'pila', population: 73776 },
  { name: 'Gorzow Wielkopolski', slug: 'gorzow-wielkopolski', population: 123762 },
  { name: 'Zielona Gora', slug: 'zielona-gora', population: 140403 },
  { name: 'Konin', slug: 'konin', population: 74151 },
  { name: 'Sopot', slug: 'sopot', population: 36049 },
  { name: 'Malbork', slug: 'malbork', population: 38478 },
  { name: 'Chojnice', slug: 'chojnice', population: 39777 },
  { name: 'Starogard Gdanski', slug: 'starogard-gdanski', population: 47773 },
  { name: 'Lebork', slug: 'lebork', population: 36909 },
  { name: 'Wejherowo', slug: 'wejherowo', population: 50310 },
  { name: 'Reda', slug: 'reda', population: 26011 },
  { name: 'Kartuzy', slug: 'kartuzy', population: 15472 },
  { name: 'Ustka', slug: 'ustka', population: 15816 },
  { name: 'Kolobrzeg', slug: 'kolobrzeg', population: 46830 },
  { name: 'Swinoujscie', slug: 'swinoujscie', population: 41115 },
  { name: 'Kamien Pomorski', slug: 'kamien-pomorski', population: 8885 },
  { name: 'Police', slug: 'police', population: 32789 },
  { name: 'Goleniow', slug: 'goleniow', population: 22398 },
  { name: 'Gryfino', slug: 'gryfino', population: 21268 },
  { name: 'Swidwin', slug: 'swidwin', population: 15619 },
  { name: 'Drawsko Pomorskie', slug: 'drawsko-pomorskie', population: 11385 },
  { name: 'Walcz', slug: 'walcz', population: 25571 },
  { name: 'Czlopa', slug: 'czlopa', population: 2284 },
  { name: 'Miedzyzdroje', slug: 'miedzyzdroje', population: 5077 },
  { name: 'Nowe Warpno', slug: 'nowe-warpno', population: 1170 },
  { name: 'Darlowo', slug: 'darlowo', population: 13182 },
  { name: 'Slawno', slug: 'slawno', population: 12511 },
  { name: 'Miastko', slug: 'miastko', population: 10635 },
  { name: 'Debica', slug: 'debica', population: 46693 },
  { name: 'Mielec', slug: 'mielec', population: 60979 },
  { name: 'Tarnobrzeg', slug: 'tarnobrzeg', population: 47111 },
  { name: 'Krosno', slug: 'krosno', population: 46548 },
  { name: 'Jaslo', slug: 'jaslo', population: 36641 },
  { name: 'Brzozow', slug: 'brzozow', population: 7677 },
  { name: 'Lesko', slug: 'lesko', population: 5612 }
];

export const polandExpanded = {
  code: 'PL',
  name: 'Poland',
  slug: 'poland',
  population: 37958000,
  topCities: [
    { name: 'Warsaw', slug: 'warsaw', population: 1790658 },
    ...polandAdditionalCities
  ]
};
